export default __webpack_public_path__ + "static/media/2-instru.45b329dd.png";